import api from "../api";

const api_type = 'v1'


export const GetMenuAll = params => { return api.post(api_type+`/base/menu`, params) }
export const GetOldgbMenu = params => { return api.post(api_type+`/base/oldgb_menu`, params) }
export const MenuSave = params => { return api.post(api_type+`/menu/save`, params) }
export const OldgbMenuSave = params => { return api.post(api_type+`/menu/oldgb_Save`, params) }




// WEBPACK FOOTER //
// ./src/api/v1/menu_api.js